import axios from 'axios'

export const baseUrl = "https://dscj.mifengli.com"

// 创建axios实例
const instance = axios.create({
  baseURL: baseUrl,
  timeout: 10000,
  headers: {
    'Content-Type': 'application/json'
  }
})

// 请求拦截器
instance.interceptors.request.use(
  (config) => {
    // 添加token到请求头
    const token = localStorage.getItem('token')
    if (token) {
      config.headers.token = token
    }
    return config
  },
  (error) => {
    return Promise.reject(error)
  }
)

// 响应拦截器
instance.interceptors.response.use(
  (response) => {
    const res = response.data

    if (res.code === 1) {
      return res
    }

    if (res.code === 0) {
      // 显示错误提示
      console.error(res.msg || res.errorMsg)
      return Promise.reject(res)
    }

    if (res.code === -1) {
      // 跳转到用户中心页面
      // window.location.href = '/userCenter'
      return Promise.reject(res)
    }

    // 处理其他情况，直接返回响应数据
    return res
  },
  (error) => {
    return Promise.reject(error)
  }
)

function request(url, method = 'GET', data = {}, options = {}, header = {}) {
  const config = {
    url,
    method: method.toLowerCase(),
    headers: {
      ...header
    },
    ...options
  }

  if (method.toUpperCase() === 'GET') {
    config.params = data
  } else {
    config.data = data
  }

  return instance(config)
}

export default request

